import Import from "./tools/import";
import Export from "./tools/export";
document.addEventListener("DOMContentLoaded", function () {
    AdminColumns.Tools = {};
    document.querySelectorAll('.ac-section.-import').forEach(function (element) {
        new Import(element);
    });
    console.log('S', 'SS');
    document.querySelectorAll('.ac-section.-export').forEach(function (element) {
        new Export(element);
    });
});
